import { Organization } from "../../../core/models/entities/Organization";
import { JetSportBox } from "../BoxView/JetSportBox";
import { BoxHeader2 } from "../BoxView/BoxHeader2";
import { BoxHeaderTypography } from "../Typographies/BoxHeaderTypography";
import { BoxContent } from "../BoxView/BoxContent";
import { BoxFooter } from "../BoxView/BoxFooter";
import { OrganizationDetails } from "./organization-details.component";
import { VendorWhiteLabelViewer } from "../../screens/organization-details/subcomponents/vendor-white-label-viewer.component";
import { useProfileContext } from "../../../contexts/ProfileContext";
import { Role } from "../../../core/models/entities/Role";
import { ManufacturerAccessControl } from "./manufacturer-access-control.component";
import { RestrictedManufacturerAccessControl } from "./restricted-manufacturer-access-control.component";
import { Manufacturer } from "../../../core/models/entities/Manufacturer";

export interface OrganizationDetailsView_VM {
  subject: string;
  organization: Organization;
  manufacturers: Manufacturer[];
  onBranchClick: (branch: Organization) => void;
  onToMainBranch: () => void;
  onToCustomers: () => void;
  onToEdit?: () => void;
}

export function OrganizationDetailsView({
  organization,
  subject,
  manufacturers,
  onBranchClick,
  onToMainBranch,
  onToCustomers,
  onToEdit,
}: OrganizationDetailsView_VM) {
  const { profile } = useProfileContext();
  const isAdmin = profile?.userOrganizationInformations?.role === Role.Admin;
  const isViewingVendor = organization.isVendor;
  const showWhiteLabelSettings = isAdmin && isViewingVendor;

  return (
    <JetSportBox>
      <BoxHeader2>
        <BoxHeaderTypography>
          {subject} - {organization.name}
        </BoxHeaderTypography>
      </BoxHeader2>
      <BoxContent>
        <OrganizationDetails
          onToMainBranch={onToMainBranch}
          onToCustomers={onToCustomers}
          onBranchClick={onBranchClick}
          organization={organization}
          onToEdit={onToEdit}
        ></OrganizationDetails>
        {showWhiteLabelSettings && (
          <VendorWhiteLabelViewer vendorId={organization.id} />
        )}

        {/* Manufacturer Access Control - Only show for vendors */}
        {isAdmin && (
          <ManufacturerAccessControl
            organizationId={organization.id}
            manufacturers={manufacturers.filter((m) => !m.isRestricted)}
          />
        )}

        {/* Restricted Manufacturer Access Control - Only show for vendors */}
        {isAdmin && (
          <RestrictedManufacturerAccessControl
            organizationId={organization.id}
            manufacturers={manufacturers.filter((m) => m.isRestricted)}
          />
        )}
      </BoxContent>
      <BoxFooter></BoxFooter>
    </JetSportBox>
  );
}
